import React, { cloneElement } from 'react'
import { Redirect, Route } from 'react-router-dom'

import { constants } from 'helpers'
import Authenticated from 'layouts/Authenticated'
import useAuthState from 'hooks/useAuthState'
import useSmartBanner from 'hooks/useSmartBanner'

const {
  AUTH_STATUS: { LOGGED_IN, LOGGED_OUT },
  ROUTES: { DISCOVER },
} = constants

export function PrivateRoute({ children, ...rest }) {
  const { status } = useAuthState()
  useSmartBanner()

  return (
    <Route
      {...rest}
      render={props =>
        status === LOGGED_IN ? (
          <Authenticated {...props} {...rest}>
            {cloneElement(children, props)}
          </Authenticated>
        ) : status === LOGGED_OUT ? (
          <Redirect
            to={{
              pathname: DISCOVER,
              state: { from: props.location },
            }}
          />
        ) : null
      }
    />
  )
}

export default PrivateRoute
